module.exports = __webpack_public_path__ + "media/images/btn-modal-close-ea1a63417d1b5beeda143723a4b7d8c0.svg";